export const SET_TYPES = 'SET_TYPES';

// initial state
const state = {
    list: {},
    active: {}
}

// getters
const getters = {
    types: state => state.list,
    type: state => state.active
}

// actions
const actions = {

    getTypes: ({commit, state}, payload) => {
        axios.get(laroute.route('api.types.index'))
            .then((response) => {
                commit(SET_TYPES, {
                    types: response.data.data
                });
            })
    }
}

// mutations
const mutations = {
    SET_TYPES: (state, payload) => {
        state.list = Object.assign({}, state.list, payload.types);
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}
